<template>
  <modal
    heading="Uh oh, something went wrong."
    :show-footer="true"
    :handle-close-click="handleCloseClick"
  >
    <p>
      Please try reloading the page. If the issue continues to occur, please
      <a href="/page/contact-us">contact us</a> or email
      <a href="mailto:service@fitnessblender.com">service@fitnessblender.com</a>
    </p>
  </modal>
</template>

<script>
import modal from './modal.vue'
export default {
  name: 'ModalError',
  components: { modal },
  /* eslint-disable vue/require-default-prop */
  props: {
    handleCloseClick: Function,
  },
}
</script>
